const StagingWatermark = () => {
  return (
    <div
      role="status"
      aria-label="Staging environment"
      className="fixed top-0 left-0 right-0 z-[100] bg-yellow-500 text-black text-center text-xs font-bold py-1 tracking-wide pointer-events-none"
    >
      STAGING ENVIRONMENT
    </div>
  );
};

export default StagingWatermark;
